// react component DetailActionTracking
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  makeStyles,
  Modal,
  Snackbar,
  TextareaAutosize,
  TextField,
  Typography,
} from '@mui/material';
import boxStyles from '../../../styles/boxStyles';
import LoadingSpinner from '../../../components/LoadingSpinner';
import DetailItemsTable from './DetailItemsTable';
import ApiService from '../../../services/ApiService';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import CreateActionTracking from '../Create';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import FileUpload from '../Create/FileUpload';
import { styled } from '@mui/material/styles';
import moment from 'moment/moment';
import { useAuth } from 'oidc-react';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';

const DetailActionTracking = () => {
  const { userData } = useAuth();
  const [userEmail, setUserEmail] = useState(userData?.profile?.email);
  const [isLoading, setIsLoading] = useState();
  const [actionTracking, setActionTracking] = useState(null);
  const location = useLocation();
  const isEdit = location.state?.isEdit || false;
  // const isEdit = false; // debug purpose
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const history = useNavigate();
  const [currentAction, setCurrentAction] = useState(null);
  const [updateMessage, setUpdateMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isOpenConfirmation, setIsOpenConfirmation] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    ApiService.getActionTrackingById(id)
      .then(({ data }) => {
        setActionTracking(data.payload);
      })
      .finally(() => {
        setIsLoading(false);
      });
    // trigger on update
  }, []);

  const ActionHeaderDetail = () => {
    return (
      <Grid container spacing={2} marginTop={3}>
        <Grid item xs={6}>
          <Grid container direction="column" spacing={1}>
            <Grid item marginBottom={2}>
              <Typography variant="subtitle1" style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '200px',
                    flexShrink: 0,
                  }}
                >
                  <strong>Nomor Action Tracking</strong>
                  <span style={{ marginRight: '6px' }}>:</span>
                </div>
                <span> {actionTracking.noActionTracking || '-'}</span>
              </Typography>
            </Grid>
            <Grid item marginBottom={2}>
              <Typography variant="subtitle1" style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '200px',
                    flexShrink: 0,
                  }}
                >
                  <strong>Judul Kegiatan</strong>
                  <span style={{ marginRight: '6px' }}>:</span>
                </div>
                <span> {actionTracking.judul || '-'} </span>
              </Typography>
            </Grid>
            <Grid item marginBottom={2}>
              <Typography variant="subtitle1" style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '200px',
                    flexShrink: 0,
                  }}
                >
                  <strong>Regional</strong>
                  <span style={{ marginRight: '6px' }}>:</span>
                </div>
                <span> {actionTracking.namaRegion || '-'}</span>
              </Typography>
            </Grid>
            <Grid item marginBottom={2}>
              <Typography variant="subtitle1" style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '200px',
                    flexShrink: 0,
                  }}
                >
                  <strong>Lokasi</strong>
                  <span style={{ marginRight: '6px' }}>:</span>
                </div>
                <span> {actionTracking.namaLokasi || '-'}</span>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container direction="column" spacing={1}>
            <Grid item marginBottom={2}>
              <Typography variant="subtitle1" style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '200px',
                    flexShrink: 0,
                  }}
                >
                  <strong>Kegiatan</strong>
                  <span style={{ marginRight: '6px' }}>:</span>
                </div>
                <span> {actionTracking.namaKegiatan || '-'}</span>
              </Typography>
            </Grid>
            <Grid item marginBottom={2}>
              <Typography variant="subtitle1" style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '200px',
                    flexShrink: 0,
                  }}
                >
                  <strong>Attachment</strong>
                  <span style={{ marginRight: '6px' }}>:</span>
                </div>
                <a
                  onClick={async (e) =>
                    await ApiService.viewFile(actionTracking.fileUploadPath, e)
                  }
                  href="#"
                  rel="noreferrer"
                  target="_blank"
                >
                  {actionTracking.fileUploadOriginalName || '-'}
                </a>
              </Typography>
            </Grid>
            <Grid item marginBottom={2}>
              <Typography variant="subtitle1" style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '200px',
                    flexShrink: 0,
                  }}
                >
                  <strong>Tanggal Disahkan</strong>
                  <span style={{ marginRight: '6px' }}>:</span>
                </div>
                <span>
                  {' '}
                  {moment(actionTracking.tglDisahkan).format('DD MMMM yyyy') ||
                    '-'}
                </span>
              </Typography>
            </Grid>
          </Grid>
          <Grid item marginBottom={2}>
            <Typography variant="subtitle1" style={{ display: 'flex' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '200px',
                  flexShrink: 0,
                }}
              >
                <strong>Email Creator</strong>
                <span style={{ marginRight: '6px' }}>:</span>
              </div>
              <span> {actionTracking.emailCreator || '-'}</span>
            </Typography>
          </Grid>
          <Grid item marginBottom={2}>
            <Typography variant="subtitle1" style={{ display: 'flex' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '200px',
                  flexShrink: 0,
                }}
              >
                <strong>Email Approver</strong>
                <span style={{ marginRight: '6px' }}>:</span>
              </div>
              <span> {actionTracking.approverEmail || '-'}</span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  };
  const handleDetailAction = (action, id) => {
    setCurrentAction({ action, id });
    setOpen(true);
  };

  const ActionItemsTable = () => {
    return (
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <Typography variant="h6" marginTop={3}>
            Action Items
          </Typography>
        </Grid>
        <Grid item xs={12} marginTop={4} container>
          <DetailItemsTable
            data={actionTracking.details}
            statusHeader={actionTracking.statusHeaderName}
            onActionSet={handleDetailAction}
          />
        </Grid>
      </Grid>
    );
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    margin: '2% 0',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 3,
  };

  const StyledFormControl = styled(FormControl)`
    width: 100%;
    margin: 0;
    margin-right: 8px;
  `;

  const StyledForm = styled('form')(({ theme }) => ({
    '& .MuiTextField-root': {
      margin: `${theme.spacing(1)}px 0 ${theme.spacing(1)}px 8px`,
    },
  }));

  const StyledTextField = styled(TextField)`
    textarea {
      width: 100%;
      resize: both;
    }
  `;

  const MemoTextArea = memo(({ handleChange }) => (
    <StyledFormControl>
      <StyledForm noValidate autoComplete="off">
        <div>
          <StyledTextField
            id="outlined-textarea"
            label="Remark"
            placeholder="Placeholder"
            multiline
            variant="outlined"
            onChange={handleChange}
            sx={{ width: '100%' }}
          />
        </div>
      </StyledForm>
    </StyledFormControl>
  ));

  const handleDetailUpdate = (updateData = null) => {
    if (updateData) {
      setUpdateMessage(updateData);
    } else {
      setUpdateMessage({
        isOk: false,
        message: 'Something went wrong, please try again later.',
      });
    }

    setOpen(false);
    setIsLoading(true);

    ApiService.getActionTrackingById(id)
      .then(({ data }) => {
        setActionTracking(data.payload);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const ActionModal = memo(({ isOpen, action, onDetailUpdate = null }) => {
    const [open, setOpen] = useState(isOpen);
    const [modalTitle, setModalTitle] = useState(action.action);
    const [currentDetailId, setCurrentDetailId] = useState(action.id);
    const [textValue, setTextValue] = useState('');
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [editedDetail, setEditedDetail] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);

    const getUsers = async (val) => {
      setIsLoading(true);
      try {
        await ApiService.getListUserAdmin(val).then((res) => {
          if (res.data.isOk) {
            setUsers(res.data.payload);
          } else {
            alert(res.data.message);
            setTimeout(() => {
              // router("/");
            }, 500);
          }
          setIsLoading(false);
        });
      } catch (error) {
        setIsLoading(false);
        alert('The Error was occured', error);
        setTimeout(() => {
          // router("/");
        }, 500);
      }
    };

    const handleKeyDown = async (e) => {
      setIsLoading(true);
      if ((e.key == 'Enter' || e.key == ' ') && e.target.value.length >= 5) {
        await getUsers(e.target.value);
      }
      setIsLoading(false);
    };

    const handlePicChange = (e, value) => {
      setEditedDetail((prevState) => ({
        ...prevState,
        picEmail: value.email,
        picDisplayName: value.namalengkap,
        picJabatan: value.jabatan === '' ? '-' : value.jabatan,
      }));
    };

    const handleReviewerChange = (e, value) => {
      setEditedDetail((prevState) => ({
        ...prevState,
        reviewerEmail: value.email,
        reviewerDisplayName: value.namalengkap,
        reviewerJabatan: value.jabatan === '' ? '-' : value.jabatan,
      }));
    };

    const handleOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleChange = useCallback((event) => {
      setTextValue(event.target.value);
    }, []);

    const handleUploadedFile = ({ id, fileName, url }) => {
      setEditedDetail({
        ...editedDetail,
        idUpload: id,
      });
    };

    const handleSubmit = () => {
      const detail = actionTracking.details.find(
        (item) => item.id === currentDetailId
      );

      setIsUpdating(true);
      let status;

      switch (action.action) {
        case 'Re-Assign':
          status = 'Open';
          break;
        default:
          status = action.action;
          break;
      }

      const updatedDetail = {
        idDetail: detail.id,
        status: status,
        noteStatus: textValue,
        uploadFileId: editedDetail.idUpload || null,
        picEmail: editedDetail.picEmail || detail.picEmail || '',
        picDisplayName:
          editedDetail.picDisplayName || detail.picDisplayName || '',
        picJabatan: editedDetail.picJabatan || detail.picJabatan || '',
        reviewerEmail: editedDetail.reviewerEmail || detail.reviewerEmail || '',
        reviewerDisplayName:
          editedDetail.reviewerDisplayName || detail.reviewerDisplayName || '',
        reviewerJabatan:
          editedDetail.reviewerJabatan || detail.reviewerJabatan || '',
        dueDateExtend:
          moment.utc(editedDetail.dueDateExtend).toDate() ||
          moment.utc(detail.dueDateExtend).toDate() ||
          null,
        isUpdateFromCreator: false,
        fungsiId: detail.fungsiId || null,
      };

      ApiService.updateDetailActionTracking(updatedDetail)
        .then((res) => {
          if (res.data.isOk) {
            onDetailUpdate({ isOk: res.data.isOk, message: res.data.message });
          } else {
            onDetailUpdate({ isOk: res.data.isOk, message: res.data.message });
          }
        })
        .catch((err) => {
          onDetailUpdate({ isOk: false, message: err.message });
        })
        .finally(() => {
          setIsUpdating(false);
        });
    };

    return (
      <Modal open={open} onClose={handleClose}>
        <Box component="div" sx={modalStyle}>
          <Grid container>
            <Grid item xs={12} sx={{ marginBottom: 3 }}>
              <h2>
                {modalTitle === 'Review' ? 'Send to Reviewer' : modalTitle}
              </h2>
            </Grid>
            {modalTitle === 'Closed' && (
              <Grid item xs={12} sx={{ marginBottom: 3 }}>
                <Typography>
                  Apakah anda yakin akan menutup pembahasan ini?
                </Typography>
              </Grid>
            )}
            {modalTitle === 'Return to PIC' && (
              <Grid item xs={12} sx={{ marginBottom: 3 }}>
                <Typography>
                  Apakah anda yakin untuk mengembalikan pembahasan ke PIC?
                </Typography>
              </Grid>
            )}
            {modalTitle === 'Extend' && (
              <Grid item xs={12} marginBottom={2}>
                <FormControl fullWidth>
                  <DesktopDatePicker
                    label="Due Date"
                    name="dueDate"
                    variant="standard"
                    value={editedDetail.dueDateExtend}
                    inputFormat="DD-MMMM-YYYY"
                    onChange={(value) =>
                      setEditedDetail({
                        ...editedDetail,
                        dueDateExtend: value.toString(),
                      })
                    }
                    renderInput={(renderInput) => (
                      <TextField {...renderInput} />
                    )}
                  />
                </FormControl>
              </Grid>
            )}
            {modalTitle !== 'Closed' && (
              <Grid item xs={12} sx={{ marginBottom: 3 }}>
                <MemoTextArea handleChange={handleChange} />
              </Grid>
            )}
            {['Extend', 'Review'].includes(modalTitle) && (
              <Grid item xs={12} marginBottom={3}>
                <FormControl fullWidth>
                  <FileUpload onFileUploaded={handleUploadedFile} />
                </FormControl>
              </Grid>
            )}
            {modalTitle === 'Re-Assign' && (
              <Grid item xs={12} marginBottom={2}>
                <FormControl fullWidth>
                  <Autocomplete
                    loading={isLoading}
                    name="picEmail"
                    onChange={handlePicChange}
                    onKeyDown={handleKeyDown}
                    required
                    getOptionLabel={(option) =>
                      `${option.namalengkap} - ${option.jabatan}`
                    }
                    options={users}
                    renderInput={(params) => (
                      <TextField {...params} label="PIC" />
                    )}
                    getOptionSelected={(option, value) =>
                      option.namalengkap === value.namalengkap
                    }
                  />
                </FormControl>
              </Grid>
            )}
            {modalTitle === 'Re-Assign' && (
              <Grid item xs={12} marginBottom={2}>
                <FormControl fullWidth>
                  <Autocomplete
                    loading={isLoading}
                    name="reviewerEmail"
                    onChange={handleReviewerChange}
                    onKeyDown={handleKeyDown}
                    required
                    getOptionLabel={(option) =>
                      `${option.namalengkap} - ${option.jabatan}`
                    }
                    options={users}
                    renderInput={(params) => (
                      <TextField {...params} label="Reviewer" />
                    )}
                    getOptionSelected={(option, value) =>
                      option.namalengkap === value.namalengkap
                    }
                  />
                </FormControl>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sx={{ marginBottom: 3 }}
              container
              justifyContent="flex-end"
            >
              {modalTitle !== 'Return to PIC' && modalTitle !== 'Closed' && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              )}
              {(modalTitle === 'Return to PIC' || modalTitle === 'Closed') && (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    sx={{ marginRight: 2 }}
                  >
                    Ya
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                    sx={{ marginLeft: 2 }}
                  >
                    Tidak
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
        </Box>
      </Modal>
    );
  });

  const markAsCompleted = () => {
    const payload = {
      ...actionTracking,
      isSubmitClosed: true,
      saveAs: 'submit',
    };

    setIsSubmitting(true);

    ApiService.updateActionTracking(payload)
      .then(({ data }) => {
        if (!data.isOk) {
          throw new Error(data.message);
        }
        setIsOpenConfirmation(false);
        setUpdateMessage({
          isOk: true,
          message: `Action Tracking marked as completed!`,
        });
      })
      .catch((e) => {
        setIsOpenConfirmation(false);
        setErrors([e.message]);
        setSnackbarOpen(true);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return !isEdit ? (
    <Container maxWidth>
      <h1>Action Tracking Details</h1>
      <Box component="div" sx={{ ...boxStyles }}>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          actionTracking && <ActionHeaderDetail />
        )}
      </Box>

      <Box
        component="div"
        sx={boxStyles}
        id="tabel2"
        style={{ marginTop: '50px' }}
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          actionTracking && <ActionItemsTable />
        )}
      </Box>

      {actionTracking &&
        actionTracking.statusHeaderName === 'Closed' &&
        (actionTracking.role === 'Admin' ||
          actionTracking.role === 'Approver') && (
          <Grid container justifyContent="center" marginTop={4}>
            <Grid item xs={12} textAlign="center">
              <Button
                variant="contained"
                color="success"
                onClick={() => setIsOpenConfirmation(true)}
                sx={{ marginLeft: 2 }}
              >
                Submit Completed
              </Button>
            </Grid>
          </Grid>
        )}

      {currentAction && (
        <ActionModal
          isOpen={open}
          action={currentAction}
          onDetailUpdate={handleDetailUpdate}
        />
      )}

      {updateMessage && (
        <Snackbar
          open={updateMessage}
          autoHideDuration={3000}
          onClose={() => {
            setUpdateMessage(null);
            setOpen(false);
          }}
          message={updateMessage.message}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        />
      )}

      <Modal open={snackbarOpen} onClose={() => setSnackbarOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2>Notifikasi</h2>
          <ul>
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
          <Button
            sx={{ marginLeft: 'auto' }}
            variant="contained"
            onClick={() => setSnackbarOpen(false)}
          >
            Tutup
          </Button>
        </Box>
      </Modal>

      <Modal
        open={isOpenConfirmation}
        onClose={setIsOpenConfirmation}
        title="Notifikasi"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2>Notifikasi</h2>
          <p>
            Apakah anda yakin untuk menyatakan status Action Tracking ini
            menjadi 'Completed'?
          </p>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              color="error"
              autoFocus
              variant="outlined"
              onClick={() => setIsOpenConfirmation(false)}
              sx={{ marginRight: '10px' }}
            >
              <span>Batal</span>
            </Button>
            <LoadingButton
              onClick={markAsCompleted}
              autoFocus
              variant="outlined"
              loading={isSubmitting}
            >
              Ya
            </LoadingButton>
          </div>
        </Box>
      </Modal>
    </Container>
  ) : (
    actionTracking && (
      <CreateActionTracking actionTrackingDetail={actionTracking} />
    )
  );
};

export default DetailActionTracking;
